import type { ComponentProps } from 'react';
import { Slot } from '@/shared/ui/slot';
import { useFormField } from './use-form-field';

type FormControlProps = ComponentProps<typeof Slot> & { hasDescription?: boolean };

/** Wires id, aria-invalid and aria-describedby onto its only child. */
export function FormControl({ hasDescription = false, ...props }: FormControlProps) {
  const { controlId, descriptionId, messageId, error } = useFormField();
  const describedBy = [hasDescription && !error ? descriptionId : null, error ? messageId : null]
    .filter(Boolean)
    .join(' ');
  return (
    <Slot
      data-slot="form-control"
      id={controlId}
      aria-invalid={error ? true : undefined}
      aria-describedby={describedBy || undefined}
      {...props}
    />
  );
}
